import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from '../../services/http-client.factory';

const api = createApi({
	reducerPath: 'api',
	baseQuery: baseQueryWithReAuth,
	endpoints: () => ({}),
	tagTypes: [
		'UserProfile',
		'Games',
		'Game',
		'Slate',
		'Match',
		'Event',
		'Lobby',
		'Market',
		'Messages',
		'LobbyUser',
		'UnreadCount',
		'LobbyUsers',
		'Categories',
		'UserScore',
		'UserAchievements',
		'LobbySource',
		'UserInsights',
		'SecondChanceMarket',
		'SecondChanceTrade',
		'ModelApiKey',
		'ProbabilityPrediction',
		'ProbabilityAchievements',
		'ProbabilityEventDetails',
		'Friends',
		'SmartRatings',
		'FeaturedImage',
		'ConsentStatus',
		'Notification',
		'Waitlist',
		'BotTrade',
		'UsersWithPnl',
		'MatchExclusion',
		'Newsfeed',
		'GeneratedPopup',
	],
});

export default api;
